import { createReducer } from "@reduxjs/toolkit";
import { getItemGroup, getItem, getCartItemApi, getItembySearchWithTotal, getItembySearchTable, GetPriceList, PostCartItemApi, removeItemInTable, SoPostApi, UpdateSalesQuotation, GetPrintData, SqPostApi, GetItembyPasting } from "./ItemPageThunk";

// Utility function to handle pending, fulfilled, and rejected actions
const handleAsyncActions = (builder, action, dataKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[dataKey] = true;
      state[dataKey] = null;
      state.error[errorKey] = null;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[dataKey] = false;
      state[dataKey] = action.payload;
      state.error[errorKey] = null;
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[dataKey] = false;
      state.error[errorKey] = action.payload;
    });
};

const initialState = {
  // Data for each API
  GetItemGrp: null,
  GetItm: null,
  GetCartItm: null,
  GetItmBySearch: null,
  GetItmBySearchTable: null,
  GetPricelist: null,
  PostCartItm: null,
  RemoveItmInTable: null,
  PostSq:null,
  PostSo:null,
  UpdateSq:null,
  ItemDetailsbyPasting:null,


  // Dynamic loading and error states for each API
  loading: {
    GetItemGrp: false,
    GetItm: false,
    GetCartItm: false,
    GetItmBySearch: false,
    GetItmBySearchTable: false,
    GetPricelist: false,
    PostCartItm: false,
    RemoveItmInTable: false,
    PostSq:false,
    PostSo:false,
    UpdateSq:false,
    ItemDetailsbyPasting:false,

  },

  error: {
    GetItemGrpError: null,
    GetItmError: null,
    GetCartItmError: null,
    GetItmBySearchError: null,
    GetItmBySearchTableError: null,
    GetPricelistError: null,
    PostCartItmError: null,
    RemoveItmInTableError: null,
    PostSoError:null,
    PostSqError:null,
    UpdateSqError:null,
    ItemDetailsbyPastingError:null,


  },
};

export const itemPageReducer = createReducer(initialState, (builder) => {
  // Handle async actions using the utility function
  handleAsyncActions(builder, getItemGroup, 'GetItemGrp', 'GetItemGrpError');
  handleAsyncActions(builder, getItem, 'GetItm', 'GetItmError');
  handleAsyncActions(builder, getCartItemApi, 'GetCartItm', 'GetCartItmError');
  handleAsyncActions(builder, getItembySearchWithTotal, 'GetItmBySearch', 'GetItmBySearchError');
  handleAsyncActions(builder, getItembySearchTable, 'GetItmBySearchTable', 'GetItmBySearchTableError');
  handleAsyncActions(builder, GetPriceList, 'GetPricelist', 'GetPricelistError');
  handleAsyncActions(builder, PostCartItemApi, 'PostCartItm', 'PostCartItmError');
  handleAsyncActions(builder, removeItemInTable, 'RemoveItmInTable', 'RemoveItmInTableError');
  handleAsyncActions(builder, SoPostApi, 'PostSo', 'PostSoError');
  handleAsyncActions(builder, SqPostApi, 'PostSq', 'PostSqError');
  handleAsyncActions(builder, UpdateSalesQuotation, 'UpdateSq', 'UpdateSqError');
  handleAsyncActions(builder, GetPrintData, 'PrintData', 'PrintDataError');
  handleAsyncActions(builder, GetItembyPasting, 'ItemDetailsbyPasting', 'ItemDetailsbyPastingError');
});

export default itemPageReducer;